import axios from "axios";
import { Message} from "element-ui";
import {
    SUCCESS_CODE,
    AUTHENTICATION_FAILED_CODE,
    LOGIN_PATH,
    API_ADDRESS
} from "../state";
import Loader from "@/public/loading";

function RequestSuccess(config){
    // 在发送请求之前做些什么
    console.log("拦截器发送请求之前",config);
    createLoading();
}
function RequestError(error){
    // 对请求错误做些什么 
    console.log("拦截器请求错误",error);
    closeLoading();
}
function ResponseSuccess(response){
    // 对响应数据做点什么
    var data = response.data || {};
    console.log("ResponseSuccess",response,data,SUCCESS_CODE)
    //错误时自动报错
    if(data.reCode !== SUCCESS_CODE){
        console.log("data.reCode",Message)
        Message({
            showClose: true,
            message: data.reMsg || "未知错误",
            type:"error"
        });
    };
    
    //身份验证失败
    if(data.reCode === AUTHENTICATION_FAILED_CODE){
        // createLoginMethod();
    };
    console.log("拦截器响应数据",response);
    closeLoading();
    return response;
}
function ResponseError(error){
    // 对响应错误做点什么
    console.log("拦截器响应错误",error)
    Message({
        showClose: true,
        message: error,
        type: 'error'
    });
    closeLoading();
}
function createLoading(){
    Loader.run();
}
function closeLoading(){
    Loader.close();
}

function createAxios() {
    var instance = axios.create({
        // baseURL:"http://localhost:8080/postData",
        baseURL: API_ADDRESS
    });
    // 添加请求拦截器
    instance.interceptors.request.use(function (config) {
        RequestSuccess(config);
        return config;
    }, function (error) {
        RequestError(error);
        return Promise.reject(error);
    });

    // 添加响应拦截器
    instance.interceptors.response.use(function (response) {
        ResponseSuccess(response);
        return response.data;
    }, function (error) {
        ResponseError(error);
        return Promise.reject(error);
    });
    return instance;
}
export default createAxios;